import { mapState } from "vuex";

export default {

  computed: {
    ...mapState('common', {
			vendor: state => state.vendor,
		}),
    vendorVars() {
			return {
				yandex: {
					name: 'Connectable',
					logoName: 'MainLogoLight',
					email: 'support@connectable.one'
				},
				google: {
					name: 'Intranetable',
					logoName: 'intranetable_logo_bord',
					email: 'welcome@intranetable.com',
				},
			}[this.vendor]
		},
  },

	async created() {
		const {data} = await this.axios.get('/api/env')
		this.$store.state.common.vendor = data.vendor
	},
}